import { render, staticRenderFns } from "./functionPermissions.vue?vue&type=template&id=49195a50&scoped=true"
import script from "./functionPermissions.vue?vue&type=script&lang=js"
export * from "./functionPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49195a50",
  null
  
)

export default component.exports